import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { useTheme } from './hooks/useTheme';
import AppLayout                from './components/layout/AppLayout';
import LoginPage                from './pages/auth/LoginPage';
import DashboardPage            from './pages/dashboard/DashboardPage';
import ContentPage              from './pages/content/ContentPage';
import ServicesPage             from './pages/services/ServicesPage';
import EcosystemPage            from './pages/services/EcosystemPage';
import ProductsPage             from './pages/products/ProductsPage';
import ProgramsPage             from './pages/programs/ProgramsPage';
import CourseBuilderPage        from './pages/programs/CourseBuilderPage';
import SubmissionsPage  from './pages/programs/SubmissionsPage';
import EnrollmentsPage          from './pages/programs/EnrollmentsPage';
import InternshipsPage          from './pages/programs/InternshipsPage';
import TrainersPage             from './pages/programs/TrainersPage';
import PartnersPage             from './pages/programs/PartnersPage';
import CertificateTemplatesPage from './pages/certificates/CertificateTemplatesPage';
import CertificatesListPage     from './pages/certificates/CertificatesListPage';
import InboxPage                from './pages/applications/InboxPage';
import UsersPage                from './pages/users/UsersPage';
import ActivityPage             from './pages/users/ActivityPage';
import MediaLibraryPage         from './pages/media/MediaLibraryPage';
import MediaSlotsPage           from './pages/media/MediaSlotsPage';
import PaymentsPage             from './pages/payments/PaymentsPage';
import OrdersPage               from './pages/orders/OrdersPage';
import SocialPage               from './pages/social/SocialPage';
import SMSPage                  from './pages/sms/SMSPage';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg-base)' }}>
      <div style={{ width:32, height:32, border:'2px solid rgba(255,255,255,0.08)', borderTopColor:'var(--accent)', borderRadius:'50%', animation:'spin 0.7s linear infinite' }}/>
    </div>
  );
  return user ? children : <Navigate to="/login" replace/>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage/>}/>
      <Route path="/*" element={
        <PrivateRoute>
          <AppLayout>
            <Routes>
              <Route index                              element={<DashboardPage/>}/>

              {/* Content */}
              <Route path="content"                    element={<ContentPage/>}/>
              <Route path="articles"                   element={<ContentPage/>}/>
              <Route path="media"                      element={<MediaLibraryPage/>}/>
              <Route path="media-slots"                element={<MediaSlotsPage/>}/>

              {/* Marketplace */}
              <Route path="services"                   element={<ServicesPage/>}/>
              <Route path="ecosystem"                  element={<EcosystemPage/>}/>
              <Route path="products"                   element={<ProductsPage/>}/>

              {/* Academy */}
              <Route path="programs"                   element={<ProgramsPage/>}/>
              <Route path="programs/:programId/course" element={<CourseBuilderPage/>}/>
              <Route path="enrollments"                element={<EnrollmentsPage/>}/>
              <Route path="submissions"                element={<SubmissionsPage/>}/>
              <Route path="internships"                element={<InternshipsPage/>}/>
              <Route path="trainers"                   element={<TrainersPage/>}/>
              <Route path="partners"                   element={<PartnersPage/>}/>

              {/* Certificates */}
              <Route path="cert-templates"             element={<CertificateTemplatesPage/>}/>
              <Route path="certificates"               element={<CertificatesListPage/>}/>

              {/* Engagement */}
              <Route path="inbox"                      element={<InboxPage/>}/>
              <Route path="payments"                   element={<PaymentsPage/>}/>
              <Route path="orders"                     element={<OrdersPage/>}/>
              <Route path="social"                     element={<SocialPage/>}/>
              <Route path="sms"                        element={<SMSPage/>}/>
              <Route path="donations"                  element={<Navigate to="/payments" replace/>}/>

              {/* System */}
              <Route path="users"                      element={<UsersPage/>}/>
              <Route path="activity"                   element={<ActivityPage/>}/>

              <Route path="*"                          element={<Navigate to="/" replace/>}/>
            </Routes>
          </AppLayout>
        </PrivateRoute>
      }/>
    </Routes>
  );
}

function ThemeWrapper({ children }) { useTheme(); return children; }

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeWrapper><AppRoutes/></ThemeWrapper>
      </AuthProvider>
    </BrowserRouter>
  );
}
